// AI insight fires a Tier 4 event but the result is data — modeled as a query.
import { useQuery } from '@tanstack/react-query';
import AiInsightService from '@/services/AiInsightService';
import type { AiInsightInput } from '@/services/AiInsightService';
import { AI_INSIGHT_KEYS } from './keys';

// OFF (2026-07-21, product): the panel auto-fired ai_insight_requested on every
// dashboard/patient-file view (~240 WF30 runs/day) for a briefing that isn't useful
// yet. Flip to true to re-enable end-to-end — WF30 + the WF5 route stay deployed.
export const AI_INSIGHT_ENABLED = false;

export function useAIInsight(input: AiInsightInput | null) {
  return useQuery({
    queryKey: [
      ...AI_INSIGHT_KEYS.all,
      input?.mode ?? null,
      input?.role ?? null,
      input?.withingsUserId ?? null,
    ] as const,
    queryFn: () => AiInsightService.getAIInsight(input!),
    enabled: AI_INSIGHT_ENABLED && !!input && (input.mode !== 'patient' || !!input.withingsUserId),
    staleTime: 5 * 60_000,
  });
}
